import { html, css, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { createRef, Ref, ref } from 'lit/directives/ref.js';

export class IxMenuAnchor extends LitElement {
  static styles = css`
    :host {
      display: block;
    }
  `;

  inputRef: Ref<HTMLInputElement> = createRef();

  @property({ type: Boolean, reflect: true }) open = false;

  @property({ type: Boolean, reflect: true }) quick = false;

  toggleOpen() {
    this.open = !this.open as boolean;
  }

  close() {
    this.open = false;
  }

  render() {
    return html`
      <span style="position: relative">
        <slot
          id="anchor"
          name="anchor"
          @click=${this.toggleOpen}
          @keydown=${this.toggleOpen}
        ></slot>
        <ix-menu
          .quick=${this.quick}
          has-overflow
          ${ref(this.inputRef)}
          id="usage-menu"
          anchor="anchor"
          .open=${this.open}
          @closing=${this.close}
        >
          <slot></slot>
        </ix-menu>
      </span>
    `;
  }
}
